const MetasearchOptions = [
  ["tripadvisor", "Tripadvisor", "TRIPADVISOR_META"],
  ["googlehotelads", "Google Hotel Ads", "GHA_META"],
  ["googleHotelAdsFBL", "Google Hotel Ads - FBL", "GHA_FBL"],
  ["bing", "Bing Hotel Ads", "BING"],
  ["trivago", "Trivago", "TRIVAGO_META"],
  ["kayak", "Kayak", "KAYAK"],
  ["skyScanner", "Skyscanner", "SKYSCANNER"],
  ["wego", "Wego", "WEGO"],
];

export const DashboardMetaseachOptions = MetasearchOptions.map(([id, label, channel_id]) => ({
  id,
  label,
  channel_id,
  isSelected: true,
}));
